"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var o=function(e){return e.scrollTop};exports.forceReflow=o;
